<template>
  <div>
    <div class="mask" v-if="showPanel" @click="showPanel = false"></div>
    <transition name="slide-fade">
      <div class="cmp-approve-panel" v-if="showPanel">
        <div class="approve-panel">
          <!-- 0 发起申请 1 审批中 2 已同意 6 审批通过 3 审批拒绝 4 已撤销 -->

          <!-- <div class="name_title">公文信息</div> -->
          <!-- <div v-if="roleType === 'mystart'" class="status-bg" :class="{
              refuse: panelStatus === '3',
              pass: panelStatus === '6',
              cancel: panelStatus === '4'
            }"></div> -->

          <h1>
            <!-- <img class="g-pic small" :src="detailData.userImage || ''" alt :onerror="defaultHeadImg" />
            &nbsp; -->
            {{ detailData.title }}
            <!-- <el-button class="btn-header" size="mini" v-if="detailData.isCancel">申请撤销</el-button> -->
            <i class="el-icon-close g-pointer fr" @click="showPanel = false"></i>
          </h1>

          <!-- 审批信息 start -->
          <div class="info">
            <!-- <div class="name_title">公文附件</div> -->
            <div class="g-label-box mb-20" v-for="(item, index) in detailData.fields" :key="index">
              <!-- 附件 -->
              <template v-if="item.name === 'attachment'">
                <span class="g-label-name m-assist tr">{{ item.label }}</span>
                <div class="fujian-box g-label-txt m-des ml-60">
                  <!-- 图片 -->
                  <div class="clearfix mb-10" v-if="item.value.img && item.value.img.length">
                    <viewer :images="item.value.img">
                      <div class="box-img mr-10" v-for="(it, index) in item.value.img" :key="index">
                        <img class="g-pointer" :src="it.attPath" alt />
                      </div>
                    </viewer>
                  </div>

                  <!-- 其他文件 -->

                  <div class="box-file-other clearfix" v-for="(it, index) in item.value.other" :key="index" @click="download(it)">
                    <svg-icon :icon-class="'file-' + it.attFileTypeStr" class="g-icon-upload" />
                    {{ it.attName }}
                  </div>
                </div>
              </template>

              <!-- 非附件 -->
              <template v-else>
                <div class="mb-10" v-if="item.title" style="color: #333;font-size:14px;line-height:20px;">
                  {{ item.title }}
                </div>
                <span class="g-label-name m-assist tr">{{item.label}}</span>
                <span class="g-label-txt m-des ml-60">{{item.value}}</span>
              </template>
            </div>

            <!-- 明细 -->
            <div class="approve-detail-box" v-for="(item, index) in detailData.detail" :key="'info-' + index">
              <p class="title mb-20">{{ item.label }}</p>
              <div class="g-label-box mb-20" v-for="(it, i) in item.arr" :key="i">
                <span class="g-label-name m-assist tr">{{ it.label }}</span>
                <span class="g-label-txt m-des ml-60">{{ it.value }}</span>
              </div>
            </div>
          </div>
          <!-- 审批信息 end -->

          <!-- <div
            class="info_item"
            v-if="detailData.oldApproverList && detailData.oldApproverList.length"
          >
            <div>原审批流程</div>
            <a class="m-btn" @click="toggleShowHead" ref="spanOne">{{
              showHead ? '收起' : '展开'
            }}</a>
          </div> -->

          <!--原审批流程状态 start -->
          <!-- <div
            class="time-line-wrap"
            v-if="
              showHead &&
                detailData.oldApproverList &&
                detailData.oldApproverList.length
            "
          >
            <el-timeline>
              <el-timeline-item
                v-for="(item, index) in detailData.oldApproverList"
                :key="index"
              >
                <div class="timeline-box">
                  <img
                    class="g-pic mini mr-10"
                    src="~@images/default-head.svg"
                    alt
                  />
                  <div class="timeline-content">
                    <div>
                      <span class="m-des mr-10">{{ item.name }}</span>
                      <span
                        :class="{
                          'm-warning': item.statusCode === '1',
                          'm-info': item.statusCode === '2',
                          'm-danger': item.statusCode === '3',
                          'm-primary': item.statusCode === '6'
                        }"
                        >{{ item.status }}</span
                      >
                      <span class="m-assist fr">{{ item.date }}</span>
                    </div>
                    <p class="m-assist">{{ item.comment }}</p>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div> -->
          <!-- 审批流程状态 end -->

          <!-- 审批流程状态 start -->
          <!-- <div class="name_title">处理流</div> -->
          <div class="time-line-wrap">
            <el-timeline>
              <el-timeline-item v-for="(it, i) in timeLineList" :key="i">
                <!-- 1审核人 2抄送人 3条件-界面不会出现 -->
                <!-- <h3 class="mb-10">
                  {{ item.type === 1 ? '处理人' : '抄送人'
                  }}{{ item.statusText && ' · ' + item.statusText }}
                  <el-tag size="mini" v-if="item.examineMode === 1">或签</el-tag>
                  <el-tag size="mini" v-if="item.examineMode === 2">会签</el-tag>
                </h3> -->
                <div class="timeline-box">
                  <!-- <img class="ml-10 mr-10" v-if="it.isTransfer" src="@images/icon-transfer-2.svg" alt style="width:16px;transform: rotate(180deg);" /> -->
                  <!-- <div class="pic-head"> -->
                    <!-- <img class="g-pic mini mr-10" :src="it.userImage || ''" alt :onerror="defaultHeadImg" /> -->
                    <!-- 0 发起申请 1 审批中 2 已同意 6 审批通过 3 审批拒绝 4 已撤销 -->
                    <!-- 抄送人 0 发起申请  10 已抄送  9 已抄送并已读 -->
                    <!-- <i class="icon icon-suc" v-if="it.status === '2'"></i>
                    <i class="icon icon-fail" v-if="it.status === '3'"></i>
                    <i class="icon icon-trans" v-if="it.status === '5'"></i>
                  </div> -->

                  <div class="timeline-content">
                    <div class="name-box m-assist">
                      <div>
                        <span class="name mr-10">{{ it.currentApproval }}</span>
    
                        <!-- <span class="ml-20">辽宁省博物馆馆长</span> -->
                      </div>
                      <span class="date fr ml-20">{{it.updateTime || '处理中'}}</span>
                      <!-- 0 发起申请 1 审批中 2 已同意 6 审批通过 3 审批拒绝 4 已撤销 -->
                      <!-- <span
                        :class="{'m-warning': it.statusCode==='1', 'm-info': it.statusCode==='2', 'm-danger': it.statusCode==='3', 'm-primary': it.statusCode==='6'}"
                      >{{it.status}}</span>-->
                      <!-- <span class="m-assist fr">{{it.date}}</span> -->
                    </div>
                    <p class="m-des">{{it.approvalComments}}</p>
                    <!-- <p class="m-assist">{{ it.comment }}</p> -->
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <!-- 审批流程状态 end -->

          <!-- 状态判断 -->
          <!-- 
            1 发起人 仅记录 不涉及
            2 主任
            3 馆长 、副馆长
            4 回到发起人
            5 抄送人 环节
            6 1个或多个抄送人全部处理完，回到发起人。 
          -->
          <!-- 处理人 不需要区分了 后台返回的数据已区分用户 -->
          <div class="res-box mt-20" v-if="(flowState=='2' || flowState=='3' || flowState=='4' || flowState=='5' || flowState=='6') && canProcess">
            <!-- <h2 class="mt-20">处理意见</h2> -->
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="选择阅办人" prop="currentApproval" v-if="flowState=='2'">
                <el-select v-model="form.currentApproval" filterable placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in personList"
                    :key="item.userId"
                    :label="item.name"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="选择抄送人" prop="chaosong" v-if="flowState=='4'">
                <el-select v-model="form.chaosong" multiple filterable placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in personList"
                    :key="item.userId"
                    :label="item.name"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="处理意见" prop="approvalComments" v-if="flowState!='6'">
                <el-input v-model="form.approvalComments" type="textarea" placeholder="请输入"></el-input>
              </el-form-item>
            </el-form>
          </div>

          <!-- 发起人 4 6流程状态是回到发起人处理 -->
          <!-- <div class="res-box mt-20" v-if="roleType == 'mystart' && (flowState=='4') && canProcess">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="选择抄送人" prop="chaosong" v-if="flowState=='4'">
                <el-select v-model="form.chaosong" multiple filterable placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in personList"
                    :key="item.userId"
                    :label="item.name"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="处理意见" prop="approvalComments" v-if="flowState=='4'">
                <el-input v-model="form.approvalComments" type="textarea" placeholder="请输入"></el-input>
              </el-form-item>
            </el-form>
          </div> -->
        </div>

        <!-- 操作 start -->
        <!-- 处理人 不需要区分了 后台返回的数据已区分用户 -->
        <div class="footer-btns" v-if="(flowState=='2' || flowState=='3' || flowState=='4' || flowState=='5' || flowState=='6' || flowState=='7') && canProcess">
          <template v-if="flowState=='2' || flowState=='3' || flowState=='4' || flowState=='5'">
            <a class="btn m-primary tc" href="javascript:;">
              <el-button class="btn-border" @click="showPanel=false">取消</el-button>
            </a>
            <div class="g-line-split gray" style="margin-left:1px;"></div>
            <a class="btn m-primary tc" href="javascript:;">
              <el-button type="primary" @click="handleSubmit">提交</el-button>
            </a>
          </template>

          <template v-if="flowState=='6'">
            <a class="btn m-primary tc" href="javascript:;" @click="handleDone">
              <svg-icon icon-class="approve-cancel" class-name="icon mr-10" />完结流转
            </a>
          </template>
          <template v-if="flowState=='7'">
            <a class="btn m-primary tc" href="javascript:;" @click="handlePrint">
              <svg-icon icon-class="print" class-name="icon mr-10" style="font-size:16px;vertical-align:-3px;" />打印
            </a>
          </template>
        </div>

        <!-- 发起人 4 6流程状态是回到发起人处理 -->
        <!-- <div class="footer-btns" v-if="roleType === 'mystart' && (flowState == '4' || flowState=='6' || flowState=='7') && canProcess">
          <template v-if="flowState=='4'">
            <a class="btn m-primary tc" href="javascript:;">
              <el-button class="btn-border" @click="showPanel=false">取消</el-button>
            </a>
            <div class="g-line-split gray" style="margin-left:1px;"></div>
            <a class="btn m-primary tc" href="javascript:;">
              <el-button type="primary" @click="handleSubmit">提交</el-button>
            </a>
          </template>

          <template v-if="flowState=='6'">
            <a class="btn m-primary tc" href="javascript:;" @click="handleDone">
              <svg-icon icon-class="approve-cancel" class-name="icon mr-10" />完结流转
            </a>
          </template>

          <template v-if="flowState=='7'">
            <a class="btn m-primary tc" href="javascript:;" @click="handlePrint">
              <svg-icon icon-class="print" class-name="icon mr-10" style="font-size:16px;vertical-align:-3px;" />打印
            </a>
          </template>
        </div> -->




        <!-- 操作 end -->

        <!-- 撤销 -->
        <!-- <dialogArea ref="dialogArea" :approveTitle="detailData.title" @refreshPanel="getDetailData" @closePanel="closePanel"></dialogArea> -->

        <!-- 转交 -->
        <!-- <el-dialog class="dialog-deliver" title="选择联系人" :append-to-body="true" :visible.sync="dialogVisible" width="360px">
          <div class="dialog-deliver-content">
            <cmp-leader-list ref="cmpLeaderList" :businessType="`copyStart`" :callFun="handleChooseAdd"></cmp-leader-list>
          </div>
        </el-dialog> -->
      </div>
    </transition>
  </div>
</template>

<script>
import cmpLeaderList from '@cmp/leader-list'
// import dialogArea from './dialog-area' // 审批面板
export default {
  components: { cmpLeaderList },
  props: {
    // 审批类型 pending:我处理的 list:流转列表 mystart:我发起的 --暂无copy:抄送我的
    roleType: {
      type: String,
      default: ''
    }
  },
  // watch: {
  //   roleType(val) {
  //     console.log(val)
  //   }
  // },
  data() {
    return {
      flowState: '1', // 1发起人 2主任 3馆长 4回到发起人 5抄送相关人 6相关人已全部处理到发起人
      canProcess: true,
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      showHead: false,
      // panelStatus: '', // 审批状态 1 审批中 2 已同意 6 审批通过 3 审批拒绝 4 已撤销
      showPanel: false,
      dialogVisible: false, // 转交弹框
      loadingSave: false, // 转交统一按钮Loading
      detailData: {},
      detailId: '',
      form: {
        currentApproval: '',
        chaosong: [],
        approvalComments: ''
      },
      rules: {
        currentApproval: [{ required: true, message: '必填', trigger: 'blur' }],
        chaosong: [{ required: true, message: '必填', trigger: 'blur' }],
        approvalComments: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      personList: [],
      timeLineList: [],
      detailObj: {}
    }
  },
  methods: {
    init(row) {
      this.showPanel = true
      // this.panelStatus = row.statusCode
      this.detailId = row.id
      console.log('detailId', this.detailId)

      

      // if (this.roleType === 'copy' && row.read !== '已读') {
      //   this.copyRead()
      //   return
      // }
      this.getDetailData()
      this.getUserList()
    },
    getDetailData() {
      this.$http
        .get('/document/bsDocumentInst/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailObj = res.result
            let data = res.result.document
            this.flowState = String(res.result.actvitySeq)
            this.canProcess = res.result.canProcess
            // this.flowState = '6'
            this.timeLineList = res.result.activity

            // 区分图片和文件
            let picUrl = []
            let attchUrl = []
            if(res.result.attactment.attFileType == 1) {
              picUrl = [ res.result.attactment ]
            } else {
              attchUrl = [ res.result.attactment ]
            }
          

            let _render = {
              "page": null,
              "success": true,
              "message": null,
              "code": 200,
              "result": {
                  "userImage": "",
                  "isCancel": false,
                  "approval": [
                      {
                          "statusText": "审批中",
                          "nodeUserList": [
                              {
                                  "userImage": "/singleMuseum/attach/getImg?fileId=160454588091815059064591620538472&s=2082",
                                  "name": "张薇",
                                  "id": "11914252127182047683211729",
                                  "type": 1,
                                  "userId": "11914252127182047683211729",
                                  "status": "0"
                              }
                          ],
                          "examineMode": "",
                          "type": 1,
                          "status": "1"
                      }
                  ],
                  "active": 0,
                  "comment": [],
                  "detail": [],
                  "title": data.name + "发起的公文流转",
                  "userName": "vivi",
                  "fields": [
                      {
                          "name": "businessLeader",
                          "label": "公文标题",
                          "value": data.name
                      },
                      {
                          "values": "[\"2048496321697961735475611296\"]",
                          "name": "businessPersons",
                          "label": "公文类型",
                          "value": data.typeDesc
                      },
                      {
                          "name": "businessPosition",
                          "label": "公文编号",
                          "value": data.code
                      },
                      {
                          "name": "businessReason",
                          "label": "来文单位",
                          "value": data.org
                      },
                      {
                          "name": "businessDate",
                          "label": "来文日期",
                          "value": data.docDate
                      },
                      {
                          "name": "attachment",
                          "label": "附件",
                          "value": {
                              "img": picUrl,
                              "other": attchUrl
                          }
                      }
                  ],
                  "userId": "166113731142417356065415720576564",
                  "status": "1"
              },
              "others": null,
              "timestamp": 1737353611407
            }

            this.detailData = _render.result
            this.resetForm()

            // 0 发起申请 1 审批中 2 已同意 6 审批通过 3 审批拒绝 4 已撤销
            // this.panelStatus = res.result.document.status
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getUserList() {
      this.$http
        .post(`/workflowConfig/copytoUserList`, {})
        .then(res => {
          if (res.success) {
            this.personList = res.result.userlist
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleSubmit() {
      console.log(this.detailObj)
      this.$refs['form'].validate(valid => {
        // 校验上部表单
        if (valid) {
          this.loadingSave = true
          this.$http
            .post('/document/bsDocumentInst/process', {
              instId: this.detailId,
              ...this.form,
              actvitySeq: this.detailObj.actvitySeq,
              currentApproval: this.form.currentApproval || this.form.chaosong.join(',')
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('提交成功')
                this.showPanel = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        } else {
          return false
        }
      })
    },
    // 完结
    handleDone() {
      this.loadingSave = true
      this.$http
        .post('/document/bsDocumentInst/process', {
          instId: this.detailId,
          actvitySeq: '6'
        })
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success('操作成功')
            this.showPanel = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    },
    // 打印
    handlePrint() {
      location.href = '/singleMuseum/document/bsDocumentInst/print?id=' + this.detailId
    },
    resetForm() {
      this.$nextTick(() => {
        if(!this.$refs['form']) return

        this.form = {
          currentApproval: '',
          chaosong: [],
          approvalComments: ''
        }
        console.log(this.$refs['form'])
        this.$refs['form'].clearValidate()
      })
    },

    // 下载
    download(item) {
      location.href =
        '/singleMuseum/attach/downloadFile?attachmentId=' + item.attId
    },
    // 抄送设置为已读
    copyRead() {
      // this.$http
      //   .post('/workflowInst/read', {
      //     actvityId: this.detailId
      //   })
      //   .then(res => {
      //     if (res.success) {
      //       this.getDetailData()
      //       this.$store.dispatch('updataSiderbarCount')
      //       this.$emit('refresh')
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
    },
    // 切换显示头部
    toggleShowHead() {
      this.showHead = !this.showHead
    },
    // 撤销
    // handleCancel() {
    //   this.$common.confirm(
    //     {
    //       title: '撤销提示',
    //       content: '你确定要撤销申请吗？'
    //     },
    //     () => {
    //       this.$refs.dialogArea.init(this.detailId, 'cancel')
    //     }
    //   )
    // },
    
    // 点击评论
    // clickComment(type) {
    //   this.$refs.dialogArea.init(this.detailId, type)
    // },
    // 点击转交
    clickDeliver() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.cmpLeaderList.showList(this.copytoList)
      })
    },
    // 选择转交人
    handleChooseAdd(item) {
      this.dialogVisible = false
      this.$http
        .post('/workflowInst/deliver', {
          actvityId: this.detailId,
          target: item.userId
        })
        .then(res => {
          if (res.success) {
            this.$message.success('转交成功')
            this.showPanel = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleDele(item) {
      this.$common.confirm(
        {
          title: '提示',
          content: '确定要删除评论吗？'
        },
        () => {
          this.$http
            .post('/workflowInst/commentDel', {
              actvityId: item.actvityId,
              delete: true
            })
            .then(res => {
              if (res.success) {
                this.$message.success('删除评论成功')
                this.getDetailData()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    closePanel() {
      this.showPanel = false
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
.cmp-approve-panel {
  position: fixed;
  right: 0;
  // right: 570px;
  top: 60px;
  bottom: 0;
  width: 570px;
  
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 1px 10px 0px rgba(150, 153, 162, 0.5);
  z-index: 2004;
  .g-label-name {
    width: 150px;
  }
  .approve-panel {
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
    padding-bottom: 10px;
    position: absolute;
    top: 0;
    bottom: 60px;
    overflow-y: auto;
    background: #fff;
    // margin-top: 60px;
    .fujian-box {
      position: relative;
      .box-img {
        float: left;
        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 4px;
        }
      }
      .box-file-other {
        // line-height: 30px;
        font-size: 14px;
        color: $color5;
        cursor: pointer;
      }
    }
    .status-bg {
      width: 130px;
      height: 130px;
      position: absolute;
      right: 30px;
      top: 80px;
      &.refuse {
        background: url(~@images/approve/refuse.png) center center no-repeat;
      }
      &.pass {
        background: url(~@images/approve/pass.png) center center no-repeat;
      }
      &.cancel {
        background: url(~@images/approve/cancel.png) center center no-repeat;
      }
    }
    h1 {
      margin-bottom: 20px;
    }
    .btn-header {
      border: 1px solid #f25151;
      color: #f25151;
      margin-left: 10px;
    }
    .info {
      padding-bottom: 10px;
      border-bottom: solid 1px $border;
      .g-label-box {
        display: flex;
      }
    }
    .approve-detail-box {
      .title {
        padding: 10px 0;
        border-bottom: solid 1px $border;
        color: $color5;
      }
    }
    .info_item {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      // margin: 30px 0;
      font-size: 14px;
      font-weight: 400;
      color: rgba(150, 153, 162, 1);
      padding-bottom: 30px;
      border-bottom: solid 1px $border;
    }
    .time-line-wrap {
      padding-top: 30px;
      border-bottom: solid 1px $border;
      .timeline-box {
        padding-bottom: 10px;
        
        display: flex;
        line-height: 24px;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
        }
        .pic-head {
          position: relative;
          .icon {
            position: absolute;
            top: -2px;
            right: 5px;
            z-index: 2;
            display: inline-block;
            width: 14px;
            height: 14px;
          }
          .icon-suc {
            background: #fff url('~@images/icon-suc.png') no-repeat;
            background-size: contain;
            border-radius: 100%;
          }
          .icon-fail {
            background: url('~@images/icon-fail.svg') no-repeat;
            background-size: contain;
          }
          .icon-trans {
            background: url('~@images/icon-trans.svg') no-repeat;
            background-size: contain;
          }
        }
        .timeline-content {
          padding-right: 20px;
          box-sizing: border-box;
          flex: 1;
          .name-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 16px;
            .name {
              color: #666;
            }
          }
          .m-des {
            font-size: 14px;
          }
        }
      }
    }
    .comment-box {
      h2 {
        margin-top: 20px;
      }
      .list {
        padding: 10px;
        color: #7f7f7f;
        li {
          padding: 10px 0;
          border-bottom: solid 1px $border;
          &:last-child {
            border-bottom: none;
          }
          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .name {
              display: flex;
              align-items: center;
              img {
                width: 32px;
                height: 32px;
                border-radius: 100%;
              }
            }
            .btn-dele {
              color: $danger;
              cursor: pointer;
            }
          }
          .des {
            color: #333;
          }
        }
      }
    }
    .copys-box {
      padding-top: 30px;
      .g-label-box {
        line-height: 24px;
        .g-label-name {
          width: auto;
        }
        span {
          display: inline-block;
        }
      }
    }
  }

  .res-box {
    /deep/ .el-form {
      .el-form-item {
        display: flex;
        .el-form-item__content {
          flex: 1;
        }
      }
    }
  }

  .footer-btns {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    box-shadow: 0px 1px 10px 0px rgba(150, 153, 162, 0.5);
    .btn {
      display: inline-block;
      width: 100%;
    }
  }
  .footer-other {
    justify-content: space-around;
    .btn-other {
      display: flex;
    }
    .btn-border {
      border: 1px solid #0590ff;
      color: #0590ff;
    }
  }

  /deep/ .el-timeline-item__content {
    position: relative;
    top: -2px;
  }
}

.dialog-deliver {
  /deep/ .cmp-leader-list {
    .m-search-wrap {
      width: 100% !important;
      box-shadow: none;
      li {
        padding-left: 0;
      }
      .input-box {
        padding: 0;
      }
    }
  }
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000000;
  z-index: 2003;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.7s;
  // transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s;
  // transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(570px);
  opacity: 0;
}
</style>
